<div class="row" *ngIf='readOnly'>
  <div class="col-md-12 col-sm-12 table-responsive no-border">
      <form [formGroup]="deviceForm" novalidate>
        <table class="table table-condensed" *ngIf="showClinicalInvestigationReferences()">
            <tbody>
                <tr>
                  <td class="col-sm-6 no-left-padding">
                          <table formArrayName="referencesForm" class="table table-inner table-condensed table-striped">
                              <tbody>
                                  <tr>
                                      <th>Clinical Investigation Reference Number</th>
                                      <th>Non-EU Applicable Countries</th>
                                  </tr>
                                  <tr formGroupName="{{i}}"
                                      *ngFor="let substance of referencesForm.controls; let i = index"
                                      >
                                      <td>
                                        <label controlName="investigationNumber"></label>
                                      </td>
                                      <td>
                                        <label controlName="applicableCountry"></label>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                  </td>
                <td class="col-sm-6"></td>
              </tr>
            </tbody>
        </table>
        <table class="table table-condensed">
            <tbody>
                <tr>
                    <td class="col-sm-12 no-left-padding no-right-padding">
                            <table formArrayName="certificateForm" class="table table-inner table-condensed table-striped">
                                <tbody>
                                    <tr>
                                        <th>Certificate Type</th>
                                        <th>Certificate Number</th>
                                        <th>Certificate Revision Number</th>
                                        <th>Notified Body ID</th>
                                        <th *ngIf="applicableRegulation != 'IVDR' && applicableRegulation != 'MDR'">Expiry Date</th>
                                    </tr>
                                    <ng-container *ngIf="certificateForm.controls.length; else emptyTemplate4fields">
                                    <tr formGroupName="{{i}}"
                                        *ngFor="let substance of certificateForm.controls; let i = index"
                                        >
                                        <td>
                                            <label controlName="certType"></label>
                                        </td>
                                        <td>
                                            <label controlName="certNumber"></label>
                                        </td>
                                        <td>
                                            <label controlName="certRevisionNumber"></label>
                                        </td>
                                        <td>
                                            <label controlName="certBody"></label>
                                        </td>
                                        <td *ngIf="applicableRegulation != 'IVDR' && applicableRegulation != 'MDR'">
                                            <label controlName="certExpDate"></label>
                                        </td>
                                    </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                    </td>
                </tr>
            </tbody>
        </table>
      </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate2fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate4fields>
  <tr>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
    <td role="gridcell"><label></label></td>
  </tr>
</ng-template>


